export const getBlob = (file) => {
  return new Promise((res, rej) => {
    const reader = new FileReader();
    let binary = "";
    reader.onload = () => {
      binary = reader.result;
      res(binary);
    };
    reader.onerror = () => {
      rej("file reading has failed");
    };
    reader.readAsArrayBuffer(file);
  });
};
export const formatFileType = (type) => {
  switch (type) {
    case "image/jpeg":
      return "Jpeg";
    case "image/png":
      return "Png";
    case "application/pdf":
      return "Pdf";
    default:
      return type;
  }
};

export async function getBase64(objectURL) {
  const response = await fetch(objectURL);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64String = reader.result;
      const formated = base64String.split(",")[1];
      resolve(formated);
    };
    reader.onerror = reject;
  });
}

export function formatFilename(string) {
  if (!string) return;
  // Remove espaços em branco no início e no final da string
  string = string.trim();

  string = string
    ?.replace(/\.(?=[^.]*\.)/g, "_")
    ?.replace(/([ _-]*)-(?=.*\.)/g, "")
    ?.replace(/([ _-]*)\./g, ".");

  // Substitui espaços por hífens
  string = string.replace(/\s+/g, "-");

  // Converte para minúsculas
  string = string.toLowerCase();

  return string;
}
